import {autoImplement} from '@/util';
import moment, {Moment} from 'moment';

export interface ApiDates {
  GeplantLieferDatum: string|null;
  GeplantLieferUhrzeit: string|null;
}

interface DatesInterface extends ApiDates {
  GeplantLieferDatumParsed: Moment|null;
  GeplantLieferUhrzeitParsed: Moment|null;
}

export default class Dates extends autoImplement<DatesInterface>() {
  static fromApi(apiDates: ApiDates): Dates {
    const GeplantLieferUhrzeitParsed = apiDates.GeplantLieferDatum && apiDates.GeplantLieferUhrzeit ?
      moment(apiDates.GeplantLieferDatum.replace('00:00', apiDates.GeplantLieferUhrzeit)) :
      apiDates.GeplantLieferUhrzeit ? moment(apiDates.GeplantLieferUhrzeit) : null;
    return new Dates({
      ...apiDates,
      GeplantLieferDatumParsed: apiDates.GeplantLieferDatum ? moment(apiDates.GeplantLieferDatum) : null,
      GeplantLieferUhrzeitParsed,
    });
  }

  get GeplantLieferUhrzeitTime() {
    return this.GeplantLieferUhrzeitParsed?.format('HH:mm');
  }

  get GeplantLieferDatumDate() {
    return this.GeplantLieferDatumParsed?.format('DD.MM.');
  }
}
